            <template>
    <div class="col-12 col-lg-9 mt-4 mt-lg-0">
                                <div class="card">
                                    <div class="row account-table-row-header">
                                            <div class="col-10 card-header"><h5>Payment History by Amount</h5></div>
                                            <div class="col-2 card-header"> <a href="/account-search" class="btn btn-xs btn-primary btn-account">New Search</a></div>
                                    </div>
                                    <div class="card-divider"></div>
                                    <div class="card-table">
                                        <div class="table-responsive-md">
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <th class="account-table-center">Transaction Date</th>
                                                        <th class="account-table-center">Payment Method</th>
                                                        <th class="account-table-right">Check/Card</th>													
                                                        <th class="account-table-right">Amount</th>
                                                        <th class="account-table-right">PO#</th>									
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td class="account-table-center">11/05/18</td>
                                                        <td class="account-table-center">Check</td>
                                                        <td class="account-table-right">1245</td>
                                                        <td class="account-table-right">10.00</td>
                                                        <td class="account-table-right"> </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="account-table-center">03/27/19</td>
                                                        <td class="account-table-center">Cash</td>
                                                        <td class="account-table-right"></td>
                                                        <td class="account-table-right">0.01</td>
                                                        <td class="account-table-right"> </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="account-table-center">03/28/19</td>
                                                        <td class="account-table-center">Cash</td>
                                                        <td class="account-table-right"></td>
                                                        <td class="account-table-right">47.81</td>
                                                        <td class="account-table-right"> </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="account-table-center">10/05/19</td>
                                                        <td class="account-table-center">Cash</td>
                                                        <td class="account-table-right"></td>
                                                        <td class="account-table-right">20.16</td>
                                                        <td class="account-table-right"> </td>
                                                    </tr>

                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div class="card-divider"></div>
                                    <div class="card-footer">
                                        
                                        <ul class="pagination">																			
                                            <li class="page-item disabled">
                                                <a class="page-link page-link--with-arrow" href="" aria-label="Previous">
                                                    <span class="page-link__arrow page-link__arrow--left" aria-hidden="true"><svg width="7" height="11">
                                                            <path d="M6.7,0.3L6.7,0.3c-0.4-0.4-0.9-0.4-1.3,0L0,5.5l5.4,5.2c0.4,0.4,0.9,0.3,1.3,0l0,0c0.4-0.4,0.4-1,0-1.3l-4-3.9l4-3.9C7.1,1.2,7.1,0.6,6.7,0.3z" />
                                                        </svg>
                                                    </span>
                                                </a>
                                            </li>
                                            <li class="page-item"><a class="page-link" href="#">1</a></li>
                                            <li class="page-item active" aria-current="page">
                                                <span class="page-link">
                                                    2
                                                    <span class="sr-only">(current)</span>
                                                </span>
                                            </li>
                                            <li class="page-item"><a class="page-link" href="#">3</a></li>
                                            <li class="page-item"><a class="page-link" href="#">4</a></li>
                                            <li class="page-item page-item--dots">
                                                <div class="pagination__dots"></div>
                                            </li>
                                            <li class="page-item"><a class="page-link" href="#">9</a></li>
                                            <li class="page-item">
                                                <a class="page-link page-link--with-arrow" href="" aria-label="Next">
                                                    <span class="page-link__arrow page-link__arrow--right" aria-hidden="true"><svg width="7" height="11">
                                                            <path d="M0.3,10.7L0.3,10.7c0.4,0.4,0.9,0.4,1.3,0L7,5.5L1.6,0.3C1.2-0.1,0.7,0,0.3,0.3l0,0c-0.4,0.4-0.4,1,0,1.3l4,3.9l-4,3.9
        C-0.1,9.8-0.1,10.4,0.3,10.7z" />
                                                        </svg>
                                                    </span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
            </template>